module.exports = __webpack_public_path__ + "img/fondo-sala.34e86370.jpg";